import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import PatientProfilePage from './PatientProfilePage.js';

export default WithGASetup(PatientProfilePage, AuthContext);
